import { Truck, Stack, Tag, Ruler, Factory, Buildings } from '@phosphor-icons/react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { useT } from '@/i18n/LanguageContext';
import Suppliers from './Suppliers';
import Locations from './Locations';
import Categories from './Categories';
import WorkCenters from './WorkCenters';
import MasterLink from './MasterLink';

export default function MasterData() {
  const { t } = useT();
  return (
    <div data-testid="mfg-master">
      <div className="mb-4">
        <h2 className="text-base font-bold tracking-tight text-zinc-900">{t('mfg.nav.master')}</h2>
        <p className="text-sm text-zinc-500 mt-0.5">{t('mfg.master.desc')}</p>
      </div>
      <Tabs defaultValue="suppliers">
        <TabsList data-testid="master-tabs" className="flex-wrap h-auto">
          <TabsTrigger value="suppliers" data-testid="master-tab-suppliers"><Truck size={15} className="mr-1.5" weight="duotone" /> {t('mfg.nav.suppliers')}</TabsTrigger>
          <TabsTrigger value="locations" data-testid="master-tab-locations"><Stack size={15} className="mr-1.5" weight="duotone" /> {t('mfg.nav.locations')}</TabsTrigger>
          <TabsTrigger value="workcenters" data-testid="master-tab-workcenters"><Factory size={15} className="mr-1.5" weight="duotone" /> {t('mfg.nav.workCenters')}</TabsTrigger>
          <TabsTrigger value="categories" data-testid="master-tab-categories"><Tag size={15} className="mr-1.5" weight="duotone" /> 在庫品目の分類</TabsTrigger>
          <TabsTrigger value="uoms" data-testid="master-tab-uoms"><Ruler size={15} className="mr-1.5" weight="duotone" /> {t('mfg.nav.uoms')}</TabsTrigger>
          <TabsTrigger value="makers" data-testid="master-tab-makers"><Buildings size={15} className="mr-1.5" weight="duotone" /> {t('mfg.maker.title')}</TabsTrigger>
        </TabsList>
        <TabsContent value="suppliers" className="mt-5"><Suppliers /></TabsContent>
        <TabsContent value="locations" className="mt-5"><Locations /></TabsContent>
        <TabsContent value="workcenters" className="mt-5"><WorkCenters /></TabsContent>
        <TabsContent value="categories" className="mt-5">
          <div className="mb-4 rounded-lg border border-zinc-200 bg-zinc-50 px-3 py-2.5"
            data-testid="master-categories-note">
            <p className="text-xs text-zinc-600">
              ここは<span className="font-semibold text-zinc-800">在庫品目の分類</span>
              （製造の在庫一覧の並べ方）です。TECHS の
              <span className="font-semibold text-zinc-800">受注分類・品番グループ</span>
              は別のマスターです。
            </p>
            <a href="/settings/taxonomy"
              className="mt-1.5 inline-flex text-xs font-semibold text-teal-700 hover:underline"
              data-testid="master-categories-taxonomy-link">
              設定 → カテゴリ・品番 を開く
            </a>
          </div>
          <Categories />
        </TabsContent>
        <TabsContent value="uoms" className="mt-5">
          <MasterLink testId="master-uoms-moved"
            title="単位は共通マスターで管理します"
            body="単位（個・本・袋・パック…）は、技術・製造・資材・IT で同じひとつの表を使います。製造だけの単位を増やすと、発注や品目登録で選べる単位が画面ごとに違ってしまうため、登録・並び替えは共通マスターで行ってください。"
            to="/settings/lookups" linkLabel="設定 → 共通マスター（単位）を開く" />
        </TabsContent>
        <TabsContent value="makers" className="mt-5">
          <MasterLink testId="master-makers-moved"
            title="メーカーは共通マスターで管理します"
            body="メーカーは全社でひとつの表（共通マスター）を使います。品目・設備・IT資産・部品受注入力のどの画面からも同じ一覧が出るよう、追加・修正は共通マスターで行ってください。"
            to="/settings/lookups" linkLabel="設定 → 共通マスター（メーカー）を開く" />
        </TabsContent>
      </Tabs>
    </div>
  );
}
